import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";
import axios from 'axios';


export const loadExpenses = async () => {
  try {
    const response = await Axios.get('/expenses');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadExpenseImages = async (id) => {
  try {
    const response = await Axios.get('/expenses/images/'+id);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


export const loadExpenseOptions = async (filter) => {
  try {
    const filters = JSON.parse(filter);
    
    const response = await Axios.get(`/expenses/search?filter=${JSON.stringify(filters)}`);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


export const loadExpense = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('/setups/expenses');
        const requestData = await response.data;
        return {...requestData, expense: {}};
        
      default:
        const respnse = await Axios.get('/expenses/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useExpenseAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('/expenses', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expense', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('/expenses/update/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expense', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const submit = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('/expenses/submit/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expense', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const uploadDoc = async (data, success) => {
    try {
      const respnse = await Axios.put('expenses/upload_doc', data, );
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('expense', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const removeImage = async (id, data, success) => {
    try {
      const respnse = await Axios.delete('expenses/images/'+id, {data: data});
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expensedelete', id);
    }catch (err) {
      throw err;
    }
  }

  return { create, update, submit, uploadDoc, removeImage };
};



export default useExpenseAPI;


